<template>
	<transition name="fade">
		<div v-if="modalOpen" class="modal" tabindex="-1" ref="basketModal">
			<div class="modal-dialog shadow">
				<div class="modal-content py-0 py-sm-2 px-4">
					<VeeForm :validation-schema="postcodeValidationSchema" v-slot="{ handleSubmit, errors }" @invalid-submit="onInvalidSubmit" as="div">
						<form class="row reg-form" @submit="handleSubmit($event, onPostcodeSubmit)" method="post" :action="this.baseUrl + '/modal-submit'" ref="modalForm">
							<div class="modal-header border-0 pb-2">
								<h3 class="modal-title">Your tyre selection</h3>
								<div class="badge bg-navy p-2 ms-auto">{{ basket.home_delivery == true ? 'Tyre delivery' : 'Fully fitted'}}</div>
								<button type="button" class="btn-close" data-bs-dismiss="modal" @click="$emit('closeModal');" aria-label="Close"></button>
							</div>
							<div class="modal-body py-0">
								<div v-for="tyre in this.basket.products" :key="tyre.id" class="d-flex border-bottom py-2 justify-content-between align-items-center">
									<div class="col-8">
										<div class="badge bg-navy mb-1" v-if="tyre.tyre_position != null && tyre.tyre_position != '' && tyre.tyre_position != 'same'">
											<small class="text-uppercase">{{ tyre.tyre_position }} tyre</small>
										</div>
										<div v-else-if="tyre.tyre_position != null && (tyre.tyre_position == 'same' || tyre.tyre_position == '')" class="badge bg-navy mb-1">
											<small class="text-uppercase">front/rear tyre</small>
										</div>
										<p class="d-block mb-0 me-3">{{ tyre.brand + ' ' + tyre.tyre_range }}</p>
										<small class="d-block mb-0">{{ tyre.description }}</small>
									</div>
									<div class="col-4 text-end">
										<p class="d-block m-0">£{{ tyre.display_price }}</p>
										<select name="quantity" id="quantity" class="d-inline-block m-2 form-select pt-1 w-50" @change="this.$parent.updateQuantity($event, tyre.st_code)">
											<option v-for="index in 5" :key="index" :value="index" :selected="index == tyre.quantity">{{ index }}</option>
										</select>
										<span @click="this.$parent.deleteFromBasket(tyre.st_code)"><i class="fa-solid fa-md fa-trash-can cursor-pointer"></i></span>
									</div>
								</div>
								<add-more-tyres
									v-if="tyrePosition != null && tyrePosition != 'same' && tyrePositionInBasket == false"
									:tyre-position="tyrePosition"
									:tyre-position-text="tyrePositionText"
									:postcode="postcode"
									:size-options="sizeOptions"
									:errors="errors"
								></add-more-tyres>
								<div class="d-flex justify-content-between align-items-center pt-2">
									<b class="float-start pt-2">Total:</b>
									<b class="float-end pt-2">£{{ basket.sub_total }}</b>
								</div>
							</div>
							<div class="modal-footer border-0">
								<ErrorMessage name="postcode">
									<span class="error"></span>
								</ErrorMessage>
                    			<Popper :content="errors.postcode" arrow placement="top" class="w-100 m-0 border-0" :show="errors.postcode ? true : false">
									<Field id="postcode" name="postcode" type="text" placeholder="Postcode" class="form-control uppercase my-2" :value="postcode" />
								</Popper>
								<button type="submit" class="btn btn-primary mx-0 my-1 w-100" :disabled="disabled">{{ continueText }}</button>
							</div>
						</form>
					</VeeForm>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
    import { Form as VeeForm, Field, ErrorMessage} from 'vee-validate';
    import * as yup from 'yup';
	import basketHelpers from '@shared/mixins/basketHelpers';

    export default {
        props: ['modal-open', 'basket', 'postcode', 'tyrePosition', 'sizeOptions'],
        emits: ['closeModal', 'basket-updated'],
		mixins: [basketHelpers],
        components: {
        	VeeForm, Field, ErrorMessage
        },
        data() {
            const postcodeValidationSchema = yup.object({
                postcode: yup.string().required().nullable()
            });

            return {
            	postcodeValidationSchema
            }
        },
        methods: {
            onPostcodeSubmit(values) {
                this.emitter.emit('isLoading', true);
				
				let vm = this;
                var postcode = values.postcode;
                var formData = new FormData();
                formData.append('postcode', postcode);

				axios.post('/modal-submit', formData)
                .then(response => {
                    window.location.href = this.baseUrl + response.data;
                })
                .catch(error => {
                    console.error("There was an error!", error);
                });
            },
			onInvalidSubmit({ values, errors, results }) {
                //Focus first invalid field
                var firstInvalidField = document.getElementsByName(Object.keys(errors)[0]);
                firstInvalidField[0].focus();
            }
        },
		computed: {
			tyrePositionText() {
				if(this.tyrePosition == 'rear') {
					return 'front';
				}
				else if(this.tyrePosition == 'front') {
					return 'rear';
				}
				else {
					return 'same';
				}
			},
			tyrePositionInBasket() {
				let tyrePositionInBasket = false;
				let vm = this;

				if(this.basket.products.length > 0) {
					_.forEach(this.basket.products, function(basketProduct, key) {
						if(basketProduct.tyre_position == vm.tyrePositionText) {
							tyrePositionInBasket = true;
						}
					});
				}

				return tyrePositionInBasket;
			}
		}
    }
</script>
<style lang="scss" scoped>
    .error {
        color: red;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
		z-index: 1090;
	}
</style>